import { atom } from 'jotai'

type AddressType = {
    flat_number?: string
    house_name?: string
    house_number?: string
    postcode: string
    query?: string
    street_name: string
    town_city: string
}

type AcquisitionPersonalData = {
    address: AddressType
    dob: string
    email: string
    first_name: string
    last_name: string
    mobile_number: string
    previous_address?: AddressType
}

type AcquisitionEventMetaData = {
    app_id?: string | string[]
    form_landing_url?: string
    gclid?: string | string[]
    msclkid?: string | string[]
    referral_url?: string
    utm_campaign?: string | string[]
    utm_content?: string | string[]
    utm_medium?: string | string[]
    utm_message_id?: string | string[]
    utm_source?: string | string[]
}

type AcquisitionEventDetails = {
    experiment_ids?: string
    journey: 'Loans Signup'
    latest_step_url?: string
    step?: string
    step_url?: string
}

interface AcquisitionPayload {
    consents?: {
        email: boolean
    }
    error?: {
        error_message: string
        error_type: string
    }
    event_details?: AcquisitionEventDetails
    form_data?: any
    meta?: AcquisitionEventMetaData
}

interface AcquisitionBasinPayload extends AcquisitionPayload {
    personal_data?: AcquisitionPersonalData
    user_id?: string
}

export interface AcquisitionDataLayerPayload extends AcquisitionPayload {}

export interface AcquisitionTrackingAtom {
    basinPayload: AcquisitionBasinPayload
    dataLayerPayload: AcquisitionDataLayerPayload
}

export const acquisitionTrackingAtom = atom<AcquisitionTrackingAtom | null>(
    null
)
